<script setup lang="ts">
import type { IconPrefix } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import type { IconSize, IconVariant } from './icon';

interface Props {
  name: string;
  variant?: IconVariant;
  size?: IconSize;
  spin?: boolean;
  fixedWidth?: boolean;
}

withDefaults(defineProps<Props>(), {
  variant: 'solid',
  size: '1x',
});

// FontAwesome addresses styles by prefix; the registry in `application/resources/Icons.js`
// keys icons the same way.
const prefixes: Record<IconVariant, IconPrefix> = {
  duotone: 'fad',
  light: 'fal',
  regular: 'far',
  solid: 'fas',
  brands: 'fab',
};
</script>

<template>
  <FontAwesomeIcon
    :icon="[prefixes[variant], name]"
    :size="size"
    :spin="spin"
    :fixed-width="fixedWidth"
  />
</template>
